// 基础配置
const config = {
  // API基础地址
  // baseURL: 'http://localhost:3000'
  baseURL: 'https://food.yylx8.vip'
}

export default config


// WEBPACK FOOTER //
// ./src/config/config.js